"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = require("react");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "className", "variant", "lineClamp", "bold", "uppercase", "noWrap", "tooltipProps", "tooltipText", "disableTooltip"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dataCy = exports.dataCy = 'Typography';
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: function root(_ref) {
      var lineClamp = _ref.lineClamp,
        bold = _ref.bold,
        uppercase = _ref.uppercase;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, lineClamp ? {
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': lineClamp,
        overflow: 'hidden'
      } : null), bold ? {
        fontWeight: 500
      } : {}), uppercase ? {
        textTransform: 'uppercase'
      } : {}), {}, {
        textDecoration: 'inherit'
      });
    }
  };
});
var DEFAULT_TOOLTIP_PROPS = {};
var Typography = function Typography(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    variant = _ref2.variant,
    lineClamp = _ref2.lineClamp,
    _ref2$bold = _ref2.bold,
    bold = _ref2$bold === void 0 ? false : _ref2$bold,
    _ref2$uppercase = _ref2.uppercase,
    uppercase = _ref2$uppercase === void 0 ? false : _ref2$uppercase,
    noWrap = _ref2.noWrap,
    _ref2$tooltipProps = _ref2.tooltipProps,
    tooltipProps = _ref2$tooltipProps === void 0 ? DEFAULT_TOOLTIP_PROPS : _ref2$tooltipProps,
    tooltipText = _ref2.tooltipText,
    disableTooltip = _ref2.disableTooltip,
    props = _objectWithoutProperties(_ref2, _excluded);
  var textRef = (0, _react.useRef)(null);
  var classes = useStyles({
    lineClamp: lineClamp,
    bold: bold,
    uppercase: uppercase
  });
  var content = children;
  var tooltip = tooltipText;
  if (!tooltipText && (lineClamp || noWrap) && !disableTooltip && typeof children === 'string') {
    tooltip = children;
  }
  if (typeof tooltip === 'string') {
    content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], _objectSpread(_objectSpread({
      arrow: true,
      title: tooltip,
      wrapper: true,
      inlineWrapper: false
    }, tooltipProps), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], _objectSpread(_objectSpread({
    "data-cy": dataCy,
    "data-variant": variant,
    variant: variant,
    className: (0, _clsx["default"])(classes.root, className),
    noWrap: noWrap,
    ref: textRef
  }, props), {}, {
    children: content
  }));
};
Typography.propTypes = _objectSpread(_objectSpread({}, _Typography["default"].propTypes), {}, {
  variant: _propTypes["default"].oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']),
  bold: _propTypes["default"].bool,
  lineClamp: _propTypes["default"].number
});
var _default = exports["default"] = Typography;